import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import { setViewUnmatched } from "../../actions/common";

import DetailsContainer from "../Common/DetailsContainer";
import CapturedPhoto from "./CapturedPhoto";

import {
  CONTEXT,
  CONTEXT_LPR,
  CONTEXT_OCR,
  OCR,
  LPR,
  FR,
  HUMAN_DETECT,
  FACE_DETECT,
  HUMAN_EXIT,
} from "../../constants/common";
import { driveInOut } from "../../constants/reducers";

import colors from "../../assets/style/colors";

const styles = {
  viewUnmatched: {
    float: "right",
    marginTop: "2px",
    fontSize: "0.875em",
    color: colors.primary,
    cursor: "pointer",
    "&:hover": { textDecoration: "underline" },
  },
};

const CapturedPhotosContainer = (props) => {
  const {
    classes,
    dispatch,
    photos,
    viewUnmatched,
    onClickPhoto,
    selectedPhoto,
  } = props;

  const unmatchedPhotosNb = photos.filter(
    (p) => p.type === OCR && !p.matched && (!p.events || p.events.length === 0)
  ).length;
  const displayedPhotosNb = photos.length - unmatchedPhotosNb;

  const renderFilteredPhotos = (filteredPhotos) => {
    return (
      <>
        {filteredPhotos.map((p) => (
          <CapturedPhoto
            key={p.url}
            type={p.type}
            img={p.url}
            values={p.values}
            matched={p.matched}
            selected={p.url === selectedPhoto}
            lastEvent={
              p.events
                ? p.events.sort(
                    (a, b) => new Date(b.created_on) - new Date(a.created_on)
                  )[0]
                : null
            }
            onClickPhoto={onClickPhoto}
            noZoom={props.blockLevel2}
            photo={p}
            //roiOverlay={p.roiOverlay}
          />
        ))}
      </>
    );
  };

  return (
    <DetailsContainer
      title={!props.nodeTitle ? I18n.get("site_capturedPhotos") : ""}
      nodeTitle={props.nodeTitle}
      style={{ padding: "0px 8px 8px 15px" }}
    >
      {unmatchedPhotosNb > 0 && (
        <Box
          component="span"
          onClick={() => dispatch(setViewUnmatched(driveInOut, !viewUnmatched))}
          className={classes.viewUnmatched}
        >
          {viewUnmatched ? I18n.get("site_hide") : I18n.get("site_view")}
          {" " + unmatchedPhotosNb + " "}
          {I18n.get("site_unmatchedPhotos")}
        </Box>
      )}
      <Grid
        container
        wrap="nowrap"
        style={{
          overflow: "auto",
          minHeight: photos.length > 0 ? "108px" : "0px",
        }}
      >
        {photos.length === 0 && (
          <span className="text-54" style={{ fontStyle: "italic" }}>
            {I18n.get("site_noPhoto")}
          </span>
        )}
        {renderFilteredPhotos(photos.filter((p) => p.type === CONTEXT))}
        {renderFilteredPhotos(photos.filter((p) => p.type === CONTEXT_LPR))}
        {renderFilteredPhotos(photos.filter((p) => p.type === CONTEXT_OCR))}
        {renderFilteredPhotos(photos.filter((p) => p.type === LPR))}
        {renderFilteredPhotos(
          photos.filter((p) =>
            [FR, HUMAN_DETECT, HUMAN_EXIT, FACE_DETECT].includes(p.type)
          )
        )}
        {renderFilteredPhotos(
          photos.filter(
            (p) =>
              p.type === OCR && (p.matched || (p.events && p.events.length > 0))
          )
        )}
        {viewUnmatched && unmatchedPhotosNb > 0 && (
          <>
            {displayedPhotosNb > 0 && (
              <Grid
                item
                style={{
                  height: "60px",
                  width: "2px",
                  minWidth: "2px",
                  backgroundColor: colors.darkGrey,
                  margin: "0px 13px",
                  marginTop: props.driver ? "7px" : "35px",
                  opacity: "0.54",
                }}
              />
            )}
            {renderFilteredPhotos(
              photos.filter(
                (p) =>
                  p.type === OCR &&
                  !p.matched &&
                  (!p.events || p.events.length === 0)
              )
            )}
          </>
        )}
      </Grid>
    </DetailsContainer>
  );
};

CapturedPhotosContainer.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      type: PropTypes.oneOf([
        CONTEXT,
        CONTEXT_LPR,
        CONTEXT_OCR,
        LPR,
        OCR,
        FR,
        FACE_DETECT,
        HUMAN_DETECT,
        HUMAN_EXIT,
      ]),
      values: PropTypes.arrayOf(PropTypes.string),
      matched: PropTypes.bool.isRequired,
    })
  ),
  onClickPhoto: PropTypes.func,
  selectedPhoto: PropTypes.string,
  nodeTitle: PropTypes.node,
};

const mapStateToProps = (state) => {
  return {
    viewUnmatched: state.common.viewUnmatched,
  };
};

export default connect(mapStateToProps)(
  withStyles(styles)(CapturedPhotosContainer)
);
